import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * Docs: https://ajaib.readme.io/reference/history-tradelist-regular-v2
 */

function getUrl() {
  return 'v3/stock/historytrade-filter/';
}

/**
 * @typedef   {object}    HistoryListRegularParams
 * @property  {string}    tickerCode
 * @property  {string}    transactionType
 * @property  {string?}   periodType
 * @property  {string?}   statusType
 * @property  {string?}   upDownPrice
 * @property  {number?}   pageSize
 */

/**
 * @typedef   {'day'|'sesi'}  OrderPeriod
 */

/**
 * @typedef   {object}  HistoryRegular
 *
 * @property  {any[]}     automation_order_item_types   (Ex: [])
 * @property  {string}    idx_order_no                  (Ex: "202306140000030291")
 * @property  {string}    idx_trade_no                  (Ex: "202306140000017210")
 * @property  {number}    lot                           (Ex: 125)
 * @property  {string}    market_type                   (Ex: "0RG")
 * @property  {string}    order_no                      (Ex: "20202")
 * @property  {number}    price_matched                 (Ex: 120)
 * @property  {number}    shares                        (Ex: 125)
 * @property  {string}    status_description            (Ex: "Matched")
 * @property  {string}    stock                         (Ex: "GOTO")
 * @property  {number}    total_price                   (Ex: 1500000)
 * @property  {string}    trade_date                    (Ex: "2023-06-14T14:45:02.000+07:00")
 * @property  {string}    transaction_type              (Ex: "1")
 */

/**
 * @typedef   {object}  HistoryListResult
 *
 * @property  {number}          count                 (Ex: 22)
 * @property  {string?}         next
 * @property  {string?}         previous              (Ex: null)
 * @property  {HistoryRegular[]}       results
 */

/**
 * @typedef   {object}  HistoryListResponse
 *
 * @property  {object}                data
 * @property  {string}                data.errCode      (Ex: "EC0000000")
 * @property  {string}                data.errMessage   (Ex: "APPROVED/OK")
 * @property  {HistoryListResult}     data.result
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 *
 * @param {string}            url
 * @param {HistoryListRegularParams} historyListParams
 * @returns
 */
function callbackFetch(
  url,
  { pageSize, periodType, statusType, tickerCode, transactionType, upDownPrice }
) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {HistoryListResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          ticker_code: tickerCode,
          transaction_type: transactionType,
          period_type: periodType,
          status_type: statusType,
          up_down_price: upDownPrice,
          page_size: pageSize,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {HistoryListRegularParams} historyListParams
 * @returns
 */
export default function getV3StockHistorytradeFilter(historyListParams = { pageSize: 15 }) {
  const url = getUrl();
  const cb = callbackFetch(url, historyListParams);
  const key = [url, JSON.stringify(historyListParams)];

  return { cb, key };
}
